import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=56d43a28"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=56d43a28&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default,AppHeaderNav: require('/builds/project/wyffest/frontend/components/app/header/AppHeaderNav.vue').default,AppAvatar: require('/builds/project/wyffest/frontend/components/app/AppAvatar.vue').default,AppLocaleSwitch: require('/builds/project/wyffest/frontend/components/app/AppLocaleSwitch.vue').default})
